import { render } from "./MassHostAcknowledge.vue?vue&type=template&id=6d66e7f4"
import script from "./MassHostAcknowledge.vue?vue&type=script&lang=js"
export * from "./MassHostAcknowledge.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__